import { isBoolean, isNumber, isString } from '../fold-helpers';
import { createWidgetNormalizer } from '../create-widget-normalizer';

/**
 * Same flat-placement lift as navigation's normalizer, plus the icon/visibility fields menu alone
 * has. See `navigation-widget-args.normalization.ts`.
 */
const menuNormalizer = createWidgetNormalizer({
    rules: [
        { target: 'textColor', accepts: isString },
        { target: 'submenuTextColor', accepts: isString },
        { target: 'fontSize', accepts: isNumber },
        { target: 'submenuFontSize', accepts: isNumber },
        { target: 'menuItemIndent', accepts: isString },
        { target: 'horizontalPosition', accepts: isString },
        { target: 'submenuListBackground', accepts: isString },
        { target: 'layoutDirection', accepts: isString },
        { target: 'menuList', accepts: Array.isArray },
        { target: 'fontStyle', accepts: Array.isArray },
        { target: 'submenuFontStyle', accepts: Array.isArray },
        { target: 'hoverEffects', accepts: (value: unknown) => typeof value === 'object' && value !== null },
        { target: 'showIconOnMobile', accepts: isBoolean },
        { target: 'iconColor', accepts: isString },
        { target: 'iconPosition', accepts: isString },
        { target: 'iconSize', accepts: isString },
        { target: 'isSynchronizeStyle', accepts: isBoolean },
        { target: 'hideOnDesktop', accepts: isBoolean },
        { target: 'hideOnTablet', accepts: isBoolean },
        { target: 'hideOnMobile', accepts: isBoolean },
    ],
    optionalData: true,
});

export function normalizeMenuWidgetArgs(raw: unknown): unknown {
    return menuNormalizer.normalize(raw);
}
